module.exports = __webpack_public_path__ + "static/img/login.44a6307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tqjg/login.png
// module id = gR11
// module chunks = 23